import React from "react";
import css from "./Info.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocationInfo } from "../../../hooks/location";

const LocationInfo = ({ location, label, value, keyLocLinks }) => {
  const { locationInfo, isLoading } = useLocationInfo(location);

  return isLoading ? (
    <FontAwesomeIcon icon="spinner" spin style={{ placeSelf: "center" }} />
  ) : locationInfo[value] ? (
    <LocationInfoResponse
      locationInfo={locationInfo}
      label={label}
      value={value}
      keyLocLinks={keyLocLinks}
    />
  ) : null;
};

export default LocationInfo;

export const LocationInfoResponse = ({
  locationInfo,
  label,
  value,
  keyLocLinks,
}) => {
  return (
    <p className={css.entryInfo}>
      <b>
        {label}
        {": "}
      </b>
      <span>
        {locationInfo[value]} &nbsp;
        {keyLocLinks ? (
          <a
            href={`${locLinks[keyLocLinks]}${locationInfo[value]}`}
            target="_blank"
          >
            <FontAwesomeIcon
              icon="fa-solid fa-arrow-up-right-from-square"
              color={"#4169e1"}
            />
          </a>
        ) : null}
      </span>
    </p>
  );
};

const locLinks = {
  accession: "https://www.uniprot.org/locations/",
  go: "https://www.ebi.ac.uk/QuickGO/term/",
};
